import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, Form, Select } from 'antd';
import { txt } from 'libs/i18n';
import { getProfilesForLanguage } from 'libs/locales/language-utils';
import { getPurposeFromSource } from 'api/user-api';
import formStyles from '../../style.module.less';
const TranscriberSettings = ({ profilesState, language, profiles, selectedSource, onChange, }) => {
    const profilesForCurrentLangAndPurp = getProfilesForLanguage(profiles, language);
    const profileError = profilesState.status === 'error' ? profilesState.error : null;
    const profileIsLoading = profilesState.status === 'loading';
    const hiddenItem = profilesForCurrentLangAndPurp.length <= 1;
    const handleChange = (value) => {
        const purpose = getPurposeFromSource(selectedSource);
        onChange(language.code, purpose, value);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Form.Item, { label: txt('transcriberType'), name: "transcriptionProfile", className: formStyles.label, hidden: hiddenItem, children: _jsx(Select, { loading: profileIsLoading, onChange: handleChange, children: profilesForCurrentLangAndPurp.map((profile) => {
                        var _a;
                        return (_jsx(Select.Option, { value: profile.profile, children: (_a = profile.tags[0]) !== null && _a !== void 0 ? _a : profile.profile }, profile.profile));
                    }) }) }), profileError !== null && (_jsx(Alert, { message: profileError, type: "error", showIcon: true }))] }));
};
export default TranscriberSettings;
